export default (params) => ({
  trigger: {
    name: 'postal_code_checker.confirm',
    params: params,
  },
  config: {
    schema: {
      status: {
        enum: [
          'has_no_restrictions',
          'invalid',
          'has_restrictions',
        ],
      },
      sub_feature: {
        enum: [
          'postal_code_checker_overlay',
          'order_block',
          'product_card',
        ],
      },
    },
    event: {
      name: 'confirm',
    },
    nonInt: false,
  },
});
